import { render, staticRenderFns } from "./USelect.vue?vue&type=template&id=c67b196a&"
import script from "./USelect.vue?vue&type=script&lang=js&"
export * from "./USelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports